import { GoFCategory } from '@flowwai-frontend/bps-officer-web/graphql'
import { Sales_Crm_Web_Common_Gof_FragmentFragment } from '@flowwai-frontend/bps-officer-web/graphql-docs'
import {
   GOFCategory,
   GOFWithFields,
   UnionField
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'
import { convertToUnionFieldType } from '@flowwai-frontend/bps-officer-web/common/data-access'

const convertGOFCategoryFromGraphQL = (category: GoFCategory): GOFCategory => {
   switch (category) {
      case GoFCategory.CustomGof:
         return GOFCategory.CustomGOF
      case GoFCategory.SystemGof:
         return GOFCategory.SystemGOF
      default:
         throw new Error(`GOF category: ${category} not handled`)
   }
}

export const convertToGoFWithFieldsType = (
   gofResponse: Sales_Crm_Web_Common_Gof_FragmentFragment
): GOFWithFields => {
   const {
      gofId,
      name,
      description,
      fields,
      category,
      orderedFieldIds,
      enableAddAnother,
      addAnotherGofResponsesLimit
   } = gofResponse

   const unionFields: UnionField[] = []
   fields.forEach(each => {
      const field = convertToUnionFieldType(each)
      field && unionFields.push(field)
   })

   return {
      gofId: gofId,
      name: name,
      description: description,
      fields: unionFields,
      orderedFieldIds,
      enableAddAnother,
      addAnotherGofResponsesLimit,
      gofCategory: convertGOFCategoryFromGraphQL(category)
   }
}
